import { Pipe, PipeTransform } from '@angular/core';
import { SubscriptionPlan } from '@core/models/builder.models';
import { BadgeCheck, Circle, Crown, LucideIconData } from 'lucide-angular';

/**
 * Maps a builder subscription plan to the Tailwind classes used by plan badges.
 */
@Pipe({ name: 'subscriptionBadge', standalone: true })
export class SubscriptionBadgePipe implements PipeTransform {
  /**
   * Returns the badge classes for a subscription plan.
   *
   * @param plan Subscription plan name from the builder model or API payload.
   * @returns Tailwind class string for the plan badge.
   */
  transform(plan: SubscriptionPlan | string): string {
    switch (plan) {
      case 'Pro':        return 'bg-talos-accent/7 text-talos-accent';
      case 'Enterprise': return 'bg-talos-ink text-[var(--talos-bg)]';
      default:           return 'bg-talos-ink/7 text-talos-ink';
    }
  }
}

/**
 * Maps a builder subscription plan to its badge icon.
 */
@Pipe({ name: 'subscriptionBadgeIcon', standalone: true })
export class SubscriptionBadgeIconPipe implements PipeTransform {
  /**
   * Returns the Lucide icon for a subscription plan.
   *
   * @param plan Subscription plan name from the builder model or API payload.
   */
  transform(plan: SubscriptionPlan | string): LucideIconData {
    switch (plan) {
      case 'Pro':        return BadgeCheck;
      case 'Enterprise': return Crown;
      default:           return Circle;
    }
  }
}
